// import { Stack } from 'contentstack'
// import {
//   CS_ENV,
//   CS_ID,
//   CS_TOKEN,
//   QUALIFICATION_CS_API_TOKEN,
//   // CS_API_REGION,
// } from 'config/appConfig'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
import { APPConfig } from 'config/appConfig'
import { trackErrorInInstana } from 'src/utils'

// const ContentStackAPI = Stack({
//   api_key: CS_ID,
//   delivery_token: CS_TOKEN,
//   environment: CS_ENV,
//   region: CS_API_REGION,
// })

// const QualificationContentStackAPI = Stack({
//   api_key: CS_ID,
//   delivery_token: QUALIFICATION_CS_API_TOKEN,
//   environment: CS_ENV,
//   region: CS_API_REGION,
// })

// Reference URLs
// {
//   "header_prototype": "https://cdn.contentstack.io/v3/content_types/header_prototype/entries/bltcb3502baadc6a2d9?environment=public-test",
//   "qualification_common_strings": "https://cdn.contentstack.io/v3/content_types/qualification_common_strings/entries/bltf8a8c88b3a43cb42?environment=public-test",
//   "footer": "https://cdn.contentstack.io/v3/content_types/footer/entries/blt0779283eb7dd0800?environment=public-test",
//   "web_page_title_banner": "https://cdn.contentstack.io/v3/content_types/web_page_title_banner/entries/blt8e7cb73167bc1997?locale=US-en&include[]=award_references&environment=public-test",
//   "featured_product_tab": "https://cdn.contentstack.io/v3/content_types/featured_product_tab/entries/blt12dacdb24519a5ce?locale=US-en&include[]=award_references&environment=public-test",
//   "brand_slider": "https://cdn.contentstack.io/v3/content_types/brand_slider/entries/blt4bbba2fc9175ca9c?locale=US-en&include[]=award_references&environment=public-test",
//   "featured_in": "https://cdn.contentstack.io/v3/content_types/featured_in/entries/bltb4cdf169215871a8?locale=US-en&include[]=award_references&environment=public-test",
//   "home_page_tagline": "https://cdn.contentstack.io/v3/content_types/home_page_tagline/entries/bltb8aca06a0750cefe?locale=US-en&include[]=award_references&environment=public-test",
//   "awards": "https://cdn.contentstack.io/v3/content_types/awards/entries/blt859970745cd8c4e8?locale=US-en&include[]=award_references&environment=public-test",
//   "news_slider": "https://cdn.contentstack.io/v3/content_types/news_slider/entries/blt7eaa44b8e16dfa44?locale=US-en&include[]=award_references&environment=public-test",
//   "home_page_disclaimer": "https://cdn.contentstack.io/v3/content_types/home_page_disclaimer/entries/blt88039e8d967b4346?locale=US-en&include[]=award_references&environment=public-test"
// }

// https://cdn.contentstack.io/v3/content_types/homepage/entries/?locale=US-en&include_reference_content_type_uid=true&environment=public-test

async function getResponseFromContentStack(options) {
  const {
    csContentType,
    locale = 'US-en',
    entryUid = '',
    isToSkipIncludes = false,
    includeFallback = false,
    returnAllEntries = false,
  } = options
  const { CS_ID = '', CS_ENV = '', CS_TOKEN = '' } = APPConfig?.getAppConfig()

  const token = options?.token || CS_TOKEN
  let baseUrl = `https://cdn.contentstack.io/v3/content_types/${csContentType}/entries/`

  let skipIncludes = [
    'header_prototype',
    'qualification_common_strings',
    'footer',
    'errorcodes',
  ].includes(csContentType)

  skipIncludes = isToSkipIncludes || skipIncludes

  if (entryUid) {
    baseUrl += `${entryUid}/`
  }

  const csUrl = new URL(baseUrl)
  csUrl.searchParams.append('environment', CS_ENV)
  csUrl.searchParams.append('locale', locale)

  if (
    csContentType == 'equinox_all_storefront_csr_translations' ||
    csContentType == 'equinox_all_storefront_ssr_translations'
  ) {
    csUrl.searchParams.append('include[]', 'all_entries')
    csUrl.searchParams.append('include[]', 'pdp_strings_reference')
    csUrl.searchParams.append('include[]', 'product_offer_strings_batch_2')
    csUrl.searchParams.append(
      'include[]',
      'account_down_convert_ba_to_member_tool_reference'
    )
    csUrl.searchParams.append('include_fallback', 'true')

    // csUrl += `?environment=${CS_ENV}&locale=${locale}&include[]=all_entries&include[]=pdp_strings_reference&include[]=account_down_convert_ba_to_member_tool_reference&include_fallback=true`
    //&include[]=common_strings_overrides&include[]=common_strings
  } else if (
    csContentType === 'nuskin_header' ||
    csContentType === 'live_nuskin_header'
  ) {
    csUrl.searchParams.append(
      'include[]',
      'top_navigation.reference.top_navigation.category.category.subcategories.subcategories'
    )
    csUrl.searchParams.append(
      'include[]',
      'region_selector.reference.regions.markets.languages'
    )
  } else if (
    csContentType === 'strings_category_page' ||
    csContentType === 'strings_product_detail_page'
  ) {
    csUrl.searchParams.append('include[]', 'common_strings')
  } else if (!skipIncludes) {
    csUrl.searchParams.append('include[]', 'award_references')
  }

  if (includeFallback) {
    csUrl.searchParams.append('include_fallback', true)
  }

  try {
    const response = await fetch(csUrl, {
      method: 'GET',
      headers: {
        api_key: CS_ID,
        access_token: CS_TOKEN,
        token,
      },
    })
      .then(res => res.json())
      .then(
        data =>
          data?.entry || (returnAllEntries ? data : data?.entries?.[0]) || {}
      )
    if (response) {
      return { ...response, apiUrl: csUrl }
    }
    return { apiUrl: csUrl, isEmptyResponse: true }
  } catch (e) {
    return {}
  }
}

const pageTranslationsContentTypes = {
  catalog: {
    contentType: 'strings_category_page',
    entryUid: 'bltb6d7f0c5abbc96f6',
  },
  search: {
    contentType: 'strings_category_page',
    entryUid: 'bltb6d7f0c5abbc96f6',
  },
  product: {
    contentType: 'strings_product_detail_page',
    entryUid: 'blt03e47cc1fa4b9804',
  },
}

export default {
  getEntry(contentTypeUid, locale = 'en-us', returnAllEntries = false) {
    console.log(`ContentStack.getEntry ==> `, {
      contentTypeUid,
      locale,
    })

    return getResponseFromContentStack({
      csContentType: contentTypeUid,
      locale,
      returnAllEntries,
    })

    // const data = new Promise((resolve, reject) => {
    //   ContentStackAPI.ContentType(contentTypeUid)
    //     .Query()
    //     .language(locale)
    //     .includeReferenceContentTypeUID()
    //     .toJSON()
    //     .find()
    //     .then(
    //       function success(result) {
    //         if (result) {
    //           resolve(result[0])
    //         } else {
    //           return reject('Internal Error')
    //         }
    //       },
    //       function error(error) {
    //         return reject(error)
    //       }
    //     )
    // })
    // console.log('data', data)
    // return data
  },
  getCSRTranslationEntry(locale = 'en-us') {
    return getResponseFromContentStack({
      csContentType: 'equinox_all_storefront_csr_translations',
      entryUid: 'blt3927bf010b9955a4',
      locale,
    })
  },
  getSSRTranslationEntry(locale = 'en-us') {
    return getResponseFromContentStack({
      csContentType: 'equinox_all_storefront_ssr_translations',
      entryUid: 'blt8696dc8bd0883ddc',
      locale,
    })
  },
  getPageTranslationEntry(locale = 'en-us', reqURL = '') {
    let pageURL =
      reqURL ||
      (typeof window !== 'undefined' && window?.location
        ? window?.location?.pathname
        : '')
    const splitPath = pageURL?.split('/')
    const pageName = splitPath.length > 1 ? splitPath[3] : ''
    const contentType =
      pageTranslationsContentTypes[pageName]?.contentType || ''
    let entryUid = pageTranslationsContentTypes[pageName]?.entryUid || ''
    if (contentType) {
      return getResponseFromContentStack({
        csContentType: contentType,
        entryUid: entryUid,
        locale,
      })
    }
    return {}
  },
  getReference(contentTypeUid, entryUid, props = {}, options = {}) {
    let activeLocale = getLocaleCodeFromUrl({
      locationProps: props,
      defaultLocale: 'en_US',
      isReverseType: true,
    })

    activeLocale =
      activeLocale?.split?.('_')?.reverse?.().join?.('-') || 'US-en'

    if (activeLocale === 'CN-zh') {
      activeLocale = 'CA-zh'
    }

    // console.log(`ContentStack.getReference ==> `, {
    //   contentTypeUid,
    //   activeLocale,
    //   entryUid,
    // })

    return getResponseFromContentStack({
      csContentType: contentTypeUid,
      entryUid,
      locale: activeLocale,
      ...options,
    })

    // const data = new Promise((resolve, reject) => {
    //   ContentStackAPI.ContentType(contentTypeUid)
    //     .Entry(entryUid)
    //     .language(activeLocale)
    //     .includeReference(['award_references'])
    //     .toJSON()
    //     .fetch()
    //     .then(
    //       function success(result) {
    //         if (result) {
    //           resolve(result)
    //         } else {
    //           return reject('Internal Error')
    //         }
    //       },
    //       function error(error) {
    //         return reject(error)
    //       }
    //     )
    // })
    // return data
  },
  getQualificationReference(contentTypeUid, entryUid, locale = 'US-en') {
    const { QUALIFICATION_CS_API_TOKEN = '' } = APPConfig?.getAppConfig()
    // console.log(`ContentStack.getQualificationReference ==> `, {
    //   contentTypeUid,
    //   locale,
    //   entryUid,
    // })

    return getResponseFromContentStack({
      csContentType: contentTypeUid,
      entryUid,
      token: QUALIFICATION_CS_API_TOKEN,
      locale,
      includeFallback: true,
    })

    // const data = new Promise((resolve, reject) => {
    //   QualificationContentStackAPI.ContentType(contentTypeUid)
    //     .Entry(entryUid)
    //     .toJSON()
    //     .fetch()
    //     .then(
    //       function success(result) {
    //         if (result) {
    //           resolve(result)
    //         } else {
    //           return reject('Internal Error')
    //         }
    //       },
    //       function error(error) {
    //         return reject(error)
    //       }
    //     )
    // })
    // return data
  },
  getSummaryTextFromContentStack(props = {}) {
    let activeLocale = getLocaleCodeFromUrl({
      locationProps: props,
      defaultLocale: 'en_US',
      isReverseType: true,
    })
    activeLocale =
      activeLocale?.split?.('_')?.reverse?.().join?.('-') || 'US-en'
    return getResponseFromContentStack({
      csContentType: 'nextgen_checkout_summary',
      entryUid: 'blt55e09a46f425da08',
      locale: activeLocale,
    })
  },

  getShippingRatesFromContentStack(props = {}) {
    const { shippingCountry = '' } = props
    let activeLocale = getLocaleCodeFromUrl({
      locationProps: props,
      defaultLocale: 'en_US',
      isReverseType: true,
    })
    const [language, localeCountry] = activeLocale?.split?.('_') || []
    // Cross-country shipping: load the shipping address country's rates
    // instead of the logged-in locale's country when an address is set.
    const country = shippingCountry?.toUpperCase?.() || localeCountry
    activeLocale = language && country ? `${country}-${language}` : 'US-en'
    return getResponseFromContentStack({
      csContentType: 'nextgen_shipping_rates',
      entryUid: 'blt0b738deeb02c2c02',
      locale: activeLocale,
    })
  },

  getErrorcodes() {
    let activeLocale = getLocaleCodeFromUrl({
      defaultLocale: 'en_US',
      isReverseType: true,
    })
    activeLocale =
      activeLocale?.split?.('_')?.reverse?.().join?.('-') || 'US-en'

    // ContentStack has no CN-zh locale; remap to CA-zh which shares the same Chinese content
    if (activeLocale === 'CN-zh') {
      activeLocale = 'CA-zh'
    }

    return getResponseFromContentStack({
      csContentType: 'errorcodes',
      entryUid: 'blt16192d6d2d32796c',
      locale: activeLocale,
      includeFallback: true,
    })
  },
}
